import React from 'react'
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';

const ServiceAttributeAssociateTable = (props) => {

    const { 
        service_name, 
        attribute_value, 
        attributes_to_be_filled, 
        api_end_point 
    } = props;

    let attributeHtml = '';
    if(attribute_value.length > 0){
        attributeHtml = attribute_value.map((attribute, i) => 
            <span className="badge badge-light-dark fs-7 fw-bold me-2 text-gray-600" key={uuidv4()}>
                <span className="text-gray-600 fw-bold fs-6">
                    {attribute.label}
                </span>
            </span>
        )
    }

    const associationDeleteOnClick = async (service_name) => {
        const associationDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if(associationDeleteSwal.isConfirmed){
            props.associationDelete(service_name)
        }
    }

    return (
        <>
            <tr>
                <td>
                    {service_name}
                </td>
                <td>
                   {attributeHtml}
                </td>
                <td>
                   {attributes_to_be_filled ? attributes_to_be_filled?.label : ''}
                </td>
                <td>
                   {api_end_point ? api_end_point : ''}
                </td>
                <td className='d-flex float-end'>
                    <div 
                        className='cursor-pointer'
                        onClick={(e) => { e.preventDefault(); associationDeleteOnClick(service_name)}}
                    >
                        <FontAwesomeIcon icon={faTrash} className='text-danger fs-3' />
                    </div>
                </td>
            </tr>
        </>
    )
}

const AssociateServiceAttributesList = (props) => {
    const { serviceAttributeAssociateData, formData } = props;
    const servicesData = formData['step4'].service_setup;
    let associationTableHtml = '';
    if (Object.keys(serviceAttributeAssociateData).length > 0) {
        associationTableHtml = Object.entries(serviceAttributeAssociateData).map(([key, value]) => {
            const apiEndPoint = servicesData.find(item => item.service_name === key);
            return (
                <ServiceAttributeAssociateTable
                    key={uuidv4()}
                    service_name={key}
                    attribute_value={value.attribute_list}
                    attributes_to_be_filled={value.attributes_to_be_filled}
                    api_end_point={apiEndPoint.api_end_point}
                    associationDelete={props.serviceAttributeAssociateDelete}
                />
            );
        });
    }

    return (
        <>
            {
                Object.keys(serviceAttributeAssociateData).length > 0 &&
                <>
                    <div className='row'>
                        <div className='col-md-12'>
                            <table className="table table-row-dashed align-middle gs-0 gy-4">
                                <thead>
                                    <tr className='fs-7 fw-bold border-0 text-gray-400'>
                                        <th className="">Service</th>
                                        <th className="">Attribute</th>
                                        <th className="">Attributes to be filled</th>
                                        <th className="">API end point</th>
                                        <th className=""></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {associationTableHtml}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default AssociateServiceAttributesList